import React from 'react'
import { useTranslation } from 'react-i18next'
import Modal from 'particles/Modal'
import Text from 'particles/Text'
import { NewTrans } from 'hooks'

interface ExtendDeadlineModalProps {
    stepName: string
    newStep1EndDate: string
    onExtendDeadline: () => void
    onClose: () => void
}

const ExtendDeadlineModal: React.FC<ExtendDeadlineModalProps> = ({
    stepName,
    newStep1EndDate,
    onExtendDeadline,
    onClose,
}) => {
    const [t] = useTranslation()

    const modalDescription = (
        <div>
            <NewTrans i18nKey="extendDeadLineDialog.subText">
                <Text scale="bodyM400" textDisplay="inline">
                    Once extended, the new deadline to request edits for this step
                </Text>
                <Text scale="bodyM700" textDisplay="inline">
                    {{ stepName }}
                </Text>
                <Text scale="bodyM400" textDisplay="inline">
                    will be
                </Text>
                <Text scale="bodyM700" textDisplay="inline">
                    {{ newStep1EndDate }}.{' '}
                </Text>
                <Text scale="bodyM400" textDisplay="inline">
                    Please request edits promptly to give Partiposters enough time to resubmit and complete the next
                    step.
                </Text>
            </NewTrans>
        </div>
    )

    return (
        <Modal
            title={t('extendDeadLineDialog.title', {
                stepName,
                newStep1EndDate,
            })}
            size="m"
            primaryButtonProps={{
                label: t('extendDeadLineDialog.primaryButton'),
            }}
            secondaryButtonProps={{
                label: t('button.cancel'),
            }}
            onConfirm={() => {
                onExtendDeadline()
            }}
            onClose={() => onClose()}
            hasIcon={false}
        >
            {modalDescription}
        </Modal>
    )
}

export default ExtendDeadlineModal
